import styled, { useTheme } from 'styled-components';
import { Heading2Text, TitleMedium } from '../../../../components/Texts';
import Button from '../../../../components/Button';
import WidthContainer from '../../../../components/WidthContainer';
import {
  PHONE_MEDIA_QUERY,
  useMediaQuery,
} from '../../../../common/responsive';
import { useEffect, useRef, useState } from 'react';
import ColorizedSpan from '../../../../components/Colorized';
import { useNavigate, useSearchParams } from 'react-router-dom';

const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  margin: 10px 0px;
`;

const BackgroundColor = styled.div`
  background-color: ${({ theme }) => theme.primary.background};
  padding: 40px 0px;
  position: absolute;
  width: 100%;
  left: 0px;
`;

const Container = styled.div`
  min-height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  gap: 24px;
  flex-direction: row;

  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: row;
    gap: 10px;
  }
`;

const CryptoGotReal = () => {
  const backgroundRef = useRef(null);
  const [siblingHeight, setSiblingHeight] = useState(undefined);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const lpd = searchParams.get('lpd');

  useEffect(() => {
    const updateHeight = () => {
      if (backgroundRef.current) {
        setSiblingHeight(backgroundRef.current.offsetHeight);
      }
    };

    updateHeight();

    const observer = new ResizeObserver(updateHeight);

    if (backgroundRef.current) {
      observer.observe(backgroundRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);

  const theme = useTheme();

  return (
    <>
      <BackgroundColor ref={backgroundRef}>
        <WidthContainer>
          <Container>
            <div
              style={{
                display: 'flex',
                gap: 24,
                flexDirection: 'column',
                width: '100%',
                marginBottom: isMobile ? '30px' : '0px',
              }}
            >
              <HeaderContainer>
                <Heading2Text
                  style={{
                    color: theme.text.title,
                    width: '100%',
                  }}
                >
                  Crypto Just Got <ColorizedSpan>Real</ColorizedSpan>
                </Heading2Text>
              </HeaderContainer>
              <div
                style={{
                  display: 'flex',
                  gap: 8,
                  flexDirection: 'column',
                  width: '100%',
                }}
              >
                <TitleMedium>
                  <b>Turn digital assets into a premium physical gift card.</b>
                </TitleMedium>
                <TitleMedium>
                  It's the first way to make crypto tangible, personal, and
                  ready to go under the tree.
                </TitleMedium>
              </div>
              <Button
                fullWidth={isMobile}
                onClick={() => {
                  navigate(
                    lpd ? `/app/gifts/create?lpd=${lpd}` : '/app/gifts/create',
                  );
                }}
              >
                Send a Gift
              </Button>
            </div>
            <InnerContainer>
              <img
                style={{ width: isMobile ? '100%' : '600px' }}
                src='/landing-v2/mailer-section.webp'
              />
            </InnerContainer>
          </Container>
        </WidthContainer>
      </BackgroundColor>
      <div style={{ height: siblingHeight }} />
    </>
  );
};

export default CryptoGotReal;
